if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form && this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class stickyCartModal extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.section;

    this.quantityInput = this.querySelector('.sticky-cart-quantity__input');
    this.minusButton = this.querySelector('[data-action="minus"]');
    this.plusButton = this.querySelector('[data-action="plus"]');
    this.addButton = this.querySelector('.sticky-cart-button');

    this.bindEvents();
    this.syncQuantity();
  }

  bindEvents() {

    this.minusButton?.addEventListener('click', () => {
      const originalQuantity = this.getOriginalQuantity();

      if (!originalQuantity) return;

      const originalMinus = originalQuantity.querySelector(
        '.quantity__button[name="minus"]'
      );

      if (originalMinus) {
        originalMinus.click();
        this.syncQuantity();
      }
    });

    this.plusButton?.addEventListener('click', () => {
      const originalQuantity = this.getOriginalQuantity();

      if (!originalQuantity) return;

      const originalPlus = originalQuantity.querySelector(
        '.quantity__button[name="plus"]'
      );

      if (originalPlus) {
        originalPlus.click();
        this.syncQuantity();
      }
    });

    this.addButton?.addEventListener('click', () => {
      const section = document.getElementById(`product-form-${this.sectionId}`);

      if (!section) return;

      const addButton =
        section.querySelector('.select-options-button') ||
        section.querySelector('[name="add"]');

      if (addButton) {
        addButton.click();
      }
    });

    const originalQuantity = this.getOriginalQuantity();

    if (originalQuantity) {
      const input = originalQuantity.querySelector('.quantity__input');

      input?.addEventListener('input', () => {
        this.syncQuantity();
      });

      input?.addEventListener('change', () => {
        this.syncQuantity();
      });
    }
  }

  getOriginalQuantity() {
    return document.getElementById(`Quantity-container-${this.sectionId}`);
  }

  syncQuantity() {
    const originalQuantity = this.getOriginalQuantity();

    if (!originalQuantity || !this.quantityInput) return;

    const input = originalQuantity.querySelector('.quantity__input');

    if (input) {
      this.quantityInput.value = input.value;
    }
  }
}

customElements.define('sticky-cart-modal', stickyCartModal);